import React, { useCallback } from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

interface SearchFilterProps {
	searchText: string;
	onSearchChange: (value: string) => void;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({
	searchText,
	onSearchChange,
}) => {
	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			onSearchChange(event.target.value);
		},
		[onSearchChange],
	);

	return (
		<TextField
			placeholder="Search metrics..."
			variant="outlined"
			size="small"
			fullWidth
			value={searchText}
			onChange={handleChange}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon style={{ color: "#999" }} />
					</InputAdornment>
				),
			}}
			style={{
				backgroundColor: "#fff",
			}}
		/>
	);
};
